import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { LogsService, UserService } from 'src/app/services/services.index';
import { LogsNav, User } from 'src/app/interfaces/interfaces.index';
import { swalError, swalSuccess } from 'src/app/shared/config/swalCommon';
import Swal from 'sweetalert2';
import { FGCompletadoRegistro } from 'src/app/interfaces/forms/completado-registro.interface';


@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})

export class ChangePasswordComponent implements OnInit {
  forma: FGCompletadoRegistro;
  user: User;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private fb: FormBuilder,
    public dpConfig: NgbDatepickerConfig,
    private userService: UserService,
    private SpinnerService: NgxSpinnerService,
    private logsService: LogsService
  ) {
    this.user = this.userService.user;
    this.forma = this.fb.group({
      email: [this.user.email , Validators.required],
      pass: [null as string | null, [Validators.required, Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}$")]],
      confirm_pass: [null as string | null, Validators.required]
    });
    this.getEmail.disable();
  }

  ngOnInit(): void {
  }

  cerrar(){
    this.activeModal.close('Close click');

  }
  completarRegistro() {
    if (!this.validacion()) { return; }
    this.SpinnerService.show();
    this.userService.changePasswordprofile(this.user.id, this.getPass.value).subscribe(() => {
      this.SpinnerService.hide();
      Swal.fire(swalSuccess('Cambio de contraseña', '¡La contraseña se cambió correctamente!, vuelva a iniciar sesión'))
        .then(() =>{
          this.activeModal.close('Close click');
          this.finishLogOut()
        } );
    }, err => this.handleError(err));
  }

  finishLogOut() {
    sessionStorage.removeItem('socialPhoto');
    this.userService.logout();
    this.router.navigate(['/login']);
  }

  handleError = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err?.userMessage));
  }


  validacion = () => (this.getEmail.value && this.cp);

  get getEmail() { return this.forma.get('email'); }
  get getPass() { return this.forma.get('pass'); }
  get getConf_pass() { return this.forma.get('confirm_pass'); }
  get cp() { return (this.getPass.value === this.getConf_pass.value); }



}
